// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"fdac143d","334":"6e133aec","453":"a7eb2345"}[chunkId] + ".chunk.js";
};